export default __webpack_public_path__ + "static/media/7.adcfd1f2.jpg";